import {
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE
} from '../actions/users';

const users = (state = [], action) => {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        error: false
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        user: action.user,
        error: false,
        messages: action.messages
      };
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        error: true,
        messages: action.messages
      };
    default:
      return state;
  }
};

export default users;



// WEBPACK FOOTER //
// ./src/reducers/users.js